/* assets/stockist-drawer.js */

class StockistDrawer {
  constructor() {
    this.drawer = document.getElementById('StockistDrawer');
    this.init();
  }

init() {
    if (!this.drawer) return;
    
    // --- NEW: Bind clicks on specific trigger buttons ---
    // This grabs any button with class 'js-stockist-trigger' (added in your main-product.liquid)
    const triggers = document.querySelectorAll('.js-stockist-trigger');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault(); // Prevents link navigation or form submission
        this.open();
      });
    });

    // --- EXISTING: Keep the custom event listener ---
    // This ensures compatibility if you trigger it via other scripts
    document.addEventListener('stockist:open', () => this.open());
    
    // --- EXISTING: Bind close events (overlay and close button) ---
    const overlay = this.drawer.querySelector('.drawer-overlay');
    const closeBtn = this.drawer.querySelector('.drawer-close-btn');
    
    if (overlay) overlay.addEventListener('click', () => this.close());
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    
    // --- EXISTING: Bind Escape key ---
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; 
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new StockistDrawer();
});